import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { render } from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import {Route } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.css';

import HomePage from './Pages/HomePage';
import ProjectsPage from './Pages/ProjectsPage';
import AboutPage from './Pages/AboutPage';
import ContactPage from './Pages/ContactPage';
import StonkBetaPage from './Pages/Stonk-Beta-Page';
import StonkBetaThankYouPage from './Pages/Stonk-Thank-You';

ReactDOM.render(
  <Router basename={process.env.PUBLIC_URL}>
    <Route path='/' component={App} />
  </Router>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
